const discArray = [
    {
    id: 1,
    type: 'Dominance',
    description: 'I am direct, strong-willed and forceful',
    attribute: 'Omnipotent',
    connector: 'So I reflect and desire the Omnipotence of God!',
    },
    {
    id: 2,
    type: 'Influence',
    description: 'I am sociable, talkative and lively',
    attribute: 'Relational',
    connector: 'So I reflect and desire the Relational strength of God!',
    },
    {
    id: 3,
    type: 'Steadiness',
    description: 'I am gentle, accommodating and soft-hearted',
    attribute: 'Peaceful',
    connector: 'So I reflect and desire the Peace of God!',
    },
    {
    id: 4,
    type: 'Conscientiousness',
    description: 'I am private, analytical and logical',
    attribute: 'Wise',
    connector: 'So I reflect and desire the Wisdom of God!',
    }
]

export default discArray;